





































import Redactor from '@/components/Redactor.vue'
import { Icon } from '@alpha/ink'
import { Component, Vue, Prop } from 'vue-property-decorator'
import { FixedComment } from '@/types/frontend'

export interface EditCommentEmission {
  commentId: string
  originalComment: string
  editedComment: string
  component: SingleComment
}

export interface DeleteCommentEmission {
  commentId: string
  component: SingleComment
}

@Component({
  components: {
    Redactor,
    Icon
  }
})
export default class SingleComment extends Vue {
  @Prop({ required: true }) comment!: FixedComment
  @Prop({ required: true }) authenticatedUserId!: string
  submitting: boolean = false
  error: boolean = false
  editMode: boolean = false
  editableComment = this.comment.comment

  get isMyComment () {
    return this.authenticatedUserId === this.comment.userid
  }

  public finish (success: boolean) {
    this.editMode = false
    this.submitting = false
    if (!success) {
      this.error = true
      setTimeout(() => { this.error = false }, 3000)
    }
  }

  makeEdit () {
    this.editableComment = this.comment.comment
    this.editMode = true
  }

  cancelEdit () {
    this.editableComment = this.comment.comment
    this.editMode = false
  }

  editComment () {
    if (this.editableComment.trim().length === 0) { return }
    this.submitting = true
    const editEmission: EditCommentEmission = {
      commentId: this.comment.commentId,
      originalComment: this.comment.comment,
      editedComment: this.editableComment,
      component: this
    }
    this.$emit('edit', editEmission)
  }

  deleteComment () {
    if (window.confirm('Are you sure you want to delete this comment?')) {
      this.submitting = true
      const deleteEmission: DeleteCommentEmission = {
        commentId: this.comment.commentId,
        component: this
      }
      this.$emit('delete', deleteEmission)
      this.editMode = false
    }
  }
}
